import { checkObjectHasEmptyProperty } from 'src/app/utils/checkObjectHasEmptyProperty';
import type { AppState } from 'src/types/appState';

export const refreshPageSelector = ({
  tealium: {
    advertiser,
    country,
    seekListingId,
    cajaFlowType,
    hirerPurchaseType,
    hirerContract,
    jobAdClassification,
    jobAdSubClassification,
    priceVisibility,
    jobAdTypeSelected,
    jobAdTypePosted,
    productTotalPrice,
    seekAdvertiserId,
    userId,
  },
  session: { productCurrency },
}: AppState) => ({
  isPageReady: !checkObjectHasEmptyProperty({
    advertiser,
    country,
    seekListingId,
    cajaFlowType,
    seekAdvertiserId,
    jobAdClassification,
    jobAdSubClassification,
    priceVisibility,
    jobAdTypePosted,
    jobAdTypeSelected,
    productTotalPrice,
    productCurrency,
    userId,
    ...(hirerPurchaseType === 'hirer-type-contract' && {
      hirerContractAdType: hirerContract?.adType,
      hirerContractBalance: hirerContract?.balance,
      hirerContractType: hirerContract?.type,
      hirerContractValue: hirerContract?.value,
    }),
  }),
});
